import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import useWindowSize from "../../utils/hooks/useWindowSize";

const Item = ({ className = "", icon, children, onClick = () => {} }) => {
  return (
    <div
      className={`rd--dropdown__item ${className}`}
      onClick={() => {
        onClick();
      }}
    >
      <div className="rd--dropdown__item-icon">{icon}</div>
      <div className="rd--dropdown__item-text">{children}</div>
    </div>
  );
};

const Separator = () => <div className="rd--dropdown__separator__items" />;

const Dropdown = ({
  open = false,
  children,
  className = "",
  position = "",
}) => {
  const [opened, setOpened] = useState(open);
  const refDropdown = useRef(null);
  const { width } = useWindowSize();
  const breakpoint = 1024;
  const isMobile = width <= breakpoint;

  const mouseDownEvt = (event) => {
    if (
      refDropdown &&
      refDropdown.current.contains(event.target) &&
      refDropdown.current === event.target.closest(".rd--dropdown")
    ) {
      return;
    }
    outsideEvt();
  };

  useEffect(() => {
    if (!isMobile) {
      document.addEventListener("mousedown", mouseDownEvt);
      return () => document.removeEventListener("mousedown", mouseDownEvt);
    }
  }, [isMobile]);

  const outsideEvt = () => {
    setOpened(false);
  };

  const renderBody = () => {
    return ReactDOM.createPortal(
      <div
        className={`rd--dropdown__overlay ${position}`}
        onClick={(e) => outsideEvt()}
      >
        <div className="rd--dropdown__content">
          <div className="rd--dropdown__header">
            <div className="rd--dropdown__heade-title">MAS OPCIONES</div>
            <div
              className="rd--dropdown__heade-close"
              onClick={() => {
                outsideEvt();
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="11.5" stroke="#A3ABCC" />
                <path
                  d="M8.25 8.25L15.7497 15.7497"
                  stroke="#A3ABCC"
                  strokeLinecap="round"
                />
                <path
                  d="M15.75 8.25L8.25031 15.7497"
                  stroke="#A3ABCC"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
          <div className="rd--dropdown__separator"></div>
          <div className="rd--dropdown__body">{children}</div>
        </div>
      </div>,
      document.body
    );
  };

  const renderElements = () => (
    <div className={`rd--dropdown__overlay ${position}`}>
      <div
        className="rd--dropdown__content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="rd--dropdown__header">
          <div className="rd--dropdown__heade-title">MAS OPCIONES</div>
          <div
            className="rd--dropdown__heade-close"
            onClick={() => {
              outsideEvt();
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="11.5" stroke="#A3ABCC" />
              <path
                d="M8.25 8.25L15.7497 15.7497"
                stroke="#A3ABCC"
                strokeLinecap="round"
              />
              <path
                d="M15.75 8.25L8.25031 15.7497"
                stroke="#A3ABCC"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>
        <div className="rd--dropdown__separator"></div>
        <div className="rd--dropdown__body">{children}</div>
      </div>
    </div>
  );

  return (
    <div className={`rd--dropdown ${className}`} ref={refDropdown}>
      <div
        className="rd--dropdown__toggle"
        onClick={() => {
          setOpened(!opened);
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="20"
            r="2"
            transform="rotate(-90 12 20)"
            fill="#A3ABCC"
          />
          <circle
            cx="12"
            cy="12"
            r="2"
            transform="rotate(-90 12 12)"
            fill="#A3ABCC"
          />
          <circle
            cx="12"
            cy="4"
            r="2"
            transform="rotate(-90 12 4)"
            fill="#A3ABCC"
          />
        </svg>
      </div>
      {opened ? (isMobile ? renderBody() : renderElements()) : ""}
    </div>
  );
};

Dropdown.Item = Item;
Dropdown.Separator = Separator;
export default Dropdown;
